var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenuBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#0D4029"
}, /*#__PURE__*/React.createElement("path", {
  d: "m17.604 19.97-9.19-9.188L7 12.196l9.19 9.189z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.19 3-9.18 9.18 1.414 1.414 9.18-9.18z"
}))));
export default SvgMenuBack;